import { BranchQrisMerchantUpdatePage } from "@/features/branch-qris-merchant/pages/BranchQrisMerchantUpdate";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/branch-qris-merchant/$id/update")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.branch_qris_config"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: BranchQrisMerchantUpdatePage,
});
